import React, { useContext, useState } from "react"
import { ThemeContext } from "./utility/context/ThemeContext"
import { ScrollView, StyleSheet, View } from "react-native"
import TotalBalance from "./total-balance"
import { Ionicons } from "@expo/vector-icons"
import { useAppSelector } from "./store"
import SpendingImpact from "./transactions/spending-impact"
import CustomerSavingsImpact from "./savings-impact"
import DashboardBusinesses from "./dashboard-businesses"
import ThemedDialog from "./style/dialog"
import Accounts from "./accounts"
import Promotion from "./promotion"

const LandingPage:React.FC = () => {
  const { user: { customer } } = useAppSelector(state => state.auth)

  const theme = useContext(ThemeContext)
  const { bgSecond } = theme.theme.colors
  const [errorModalVisible, setErrorModalVisible] = useState(false)

  return (
    <>
      <ScrollView
        bounces={false}
        style={[styles.container, {backgroundColor: bgSecond}]}
        contentContainerStyle={{backgroundColor: bgSecond, paddingBottom: 10}}
      >
        <View style={{gap: 10}}>
          <TotalBalance/>
          <Accounts />
        </View>
        {
          customer && customer.savingsImpact ? <>
            <View style={[styles.horizontalDivider]} />
            <CustomerSavingsImpact />
          </> : null
        }
        <View style={[styles.horizontalDivider]} />
        <SpendingImpact />
        <View style={[styles.horizontalDivider]} />
        <DashboardBusinesses />
        {
          customer && customer.promotion ? <>
            <View style={[styles.horizontalDivider]} />
            <Promotion />
          </> : null
        }
      </ScrollView>
      <ThemedDialog
        title={"Error fetching data"}
        subMessage="The issue has been reported and we will be looking into it shortly. Please try again later."
        visible={errorModalVisible}
        errorAnimation={errorModalVisible}
        options={[
          {
            title: "Okay",
            role: "cancel",
            onPress: () => setErrorModalVisible(false),
            icon: <Ionicons name="checkmark" size={24} />
          }
        ]}
      />
    </>
  )
}

export default LandingPage

const styles = StyleSheet.create({
  container: {
    flex:1,
    width: "100%",
    overflow: "hidden"
  },
  actionSheetHeader: {
    width: "100%",
    height: 48,
    borderBottomWidth: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  saveButton: {
    height: 42,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
    marginTop: 10
  },
  horizontalDivider: {
    width: "100%",
    // borderTopWidth: 1,
    marginVertical: 20,
    alignSelf: "center",
  }
})